import { NavItem, TableStaticActions, useModal, withModalConditionalRender } from '@billy/design-system'
import { ReactElement, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { DeleteUmbrellaInvitationModal as DeleteUmbrellaInvitationModalComponent } from '../../../DeleteUmbrellaInvitationModal'

interface InvitationsTableHoverActionsProps {
  invitationId: string
  umbrellaId: string
}

enum InvitationsTableStaticActionType {
  Delete = 'delete',
}

const DeleteUmbrellaInviteModal = withModalConditionalRender(DeleteUmbrellaInvitationModalComponent)

export const getDeleteUmbrellaInviteModalId = (id: string) => `${id}-delete-umbrella-user-invite`

export const InvitationsTableStaticActions = ({
  invitationId,
  umbrellaId,
}: InvitationsTableHoverActionsProps): ReactElement => {
  const { t } = useTranslation()
  const deleteUmbrellaInviteModalId = getDeleteUmbrellaInviteModalId(invitationId)
  const { open: openDeleteUmbrellaInviteModal } = useModal(deleteUmbrellaInviteModalId)

  const staticActionsItems: NavItem<InvitationsTableStaticActionType>[] = useMemo(
    () => [
      {
        id: 'delete',
        children: t('umbrella_users.invitationTable.delete'),
        value: InvitationsTableStaticActionType.Delete,
        iconLeft: 'trash',
      },
    ],
    [t],
  )

  const handleStaticActionSelect = useCallback(openDeleteUmbrellaInviteModal, [openDeleteUmbrellaInviteModal])

  return (
    <>
      <TableStaticActions items={staticActionsItems} onSelect={handleStaticActionSelect} />
      <DeleteUmbrellaInviteModal id={deleteUmbrellaInviteModalId} umbrellaId={umbrellaId} invitationId={invitationId} />
    </>
  )
}
